import React, { Suspense, useEffect } from 'react';
import { Global404, Route404 } from '@saviynt/common';
import { OverlayProvider } from '@saviynt/design-system';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { RuleDetails } from '../components';
import { RulesProvider } from '../context';
import { type RootState } from '../services/types';
import REQUEST_BASE_URL from '../utils/constants';
import {
  hideHostAppElements,
  hideHostAppElementsCleanup,
  removeDynamicBodyClasses,
} from '../utils/hideHostElements';

import Dashboard from './Dashboard/Dashboard';

const queryClient = new QueryClient();

function Routes() {
  const { messages } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    /* hide host app elements not needed for Gen2 UI */
    hideHostAppElements();
    removeDynamicBodyClasses();

    return () => {
      hideHostAppElementsCleanup();
    };
  }, []);

  // Always use REQUEST_BASE_URL since this component is only used when embedded
  const baseUrl = REQUEST_BASE_URL;

  const allowedRoutes = {
    staticRoutes: ['/', '/rule-details/:id'],
    dynamicRoutes: [],
    blockedUrlList: [],
    blockedNames: [],
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense key='Rules'>
        <IntlProvider locale='en' messages={messages}>
          <RulesProvider>
            <OverlayProvider>
              <Router basename={baseUrl}>
                <Route404 routes={allowedRoutes} render={() => <Global404 />}>
                  <Route exact path='/' component={Dashboard} />
                  <Route
                    exact
                    path='/rule-details/:id'
                    component={RuleDetails}
                  />
                </Route404>
              </Router>
            </OverlayProvider>
          </RulesProvider>
        </IntlProvider>
      </Suspense>
    </QueryClientProvider>
  );
}

export default Routes;
